import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AddressBookComponent } from './address-book.component';
import { ErrorsModule } from '@fgb/portal-component-library/src/lib/shared/errors';
import { LoadingModule } from '@fgb/portal-component-library/src/lib/shared/loading';
import { FormsModule } from '@angular/forms';

import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { ConfirmModalModule } from '@fgb/portal-component-library/src/lib/shared/confirm-modal';

@NgModule({
  declarations: [AddressBookComponent],
  imports: [
    CommonModule,
    ErrorsModule,
    LoadingModule,
    FormsModule,
    ConfirmModalModule,
    FGBSharedModule
  ],
  exports: [AddressBookComponent],
})
export class AddressBookModule {}
